import React, { useContext, useEffect, useState } from "react";
import { LoaderContext, getContext } from "../../../../Helpers/Context/Context";
import { APICall } from "../../../../Helpers/Network/APICalls";
import { ApiStatus } from "../../../../Helpers/Enums/ApiStatus";
import { useLocation } from "react-router-dom";
import {
  GetAllSuretiesByMemberId,
  RemoveSurety,
  ReplaceSurety,
} from "../../../../Helpers/APIEndPoints/EndPoints";
import { IconButton, Tooltip, Typography } from "@mui/material";
import { Modal } from "react-bootstrap";
import InputForm from "../../../../Components/InputForm/InputForm";
import ButtonComponent from "../../../../Components/ButtonForm/Button";
import notify, { ToastType } from "../../../../Helpers/ToastNotification";
import DynamicGrid from "../../../../Components/DynamicGrid/DynamicGrid";
import OverflowTip from "../../../../Components/OverflowToolTip/OverflowToolTip";
import { DATE_DISPLAY_FORMAT } from "../../../../Helpers/Constants/Constants";
import moment from "moment";
import { RoleEnum } from "../../../../Helpers/Enums/RoleEnum";

const SuretyMemberView = () => {
  const context = getContext();
  const { state } = useLocation();
  
  const { showLoader, hideLoader } = useContext(LoaderContext);
  const [sureties, setSureties] = useState([]);
  const [showSuretyReplaceModal, setShowSuretyReplaceModal] =
    useState<boolean>(false);
  const [newSuretyMemberNo, setNewSuretyMemberNo] = useState<string>("");
  const [suretyForReplacement, setSuretyForReplacement] = useState<any>(null);
  const [error, setError] = React.useState<any>({});
  const [sortDirection, setSortDirection] = useState("");
  const [pageSize] = useState(10);
  const [dataCount, setDataCount] = useState(0);
  const [start, setStart] = useState(0);
  const [sortColumn, setSortColumn] = useState("");
  const [searchText, setSearchText] = useState("");
  const [dashboardData, setDashboardData] = useState([]);

  const getSuretyDetails = async () => {
    showLoader();
    try {
      //await sleep(2500);
      const data = {
        MemberId: state ? state.memberId : context?.MemberId,
      };

      const resp = await APICall(GetAllSuretiesByMemberId, data);

      if (resp.Status === ApiStatus.OK && resp?.Data?.length > 0) {
        setSureties(resp?.Data);
        const dataArr = resp?.Data;
        for (let d = 0; d < dataArr.length; d++) {
          const data = dataArr[d];
          data.SuretyNo = d + 1;
        }
        setDashboardData(dataArr);
        setDataCount(dataArr.length);
      }
    } finally {
      hideLoader();
    }
  };

  const removeSurety = async () => {
    showLoader();
    try {
      
      const data = {
        LoanId: suretyForReplacement?.Lrd_Id,
        SuretyId: suretyForReplacement?.Lrs_SurityId,
        InternalMemberId: (context?.CurrentRoleId === RoleEnum.InternalTeam || context?.CurrentRoleId == RoleEnum.Admin) ? context?.MemberId : null,
        IsInternalTeam: (context?.CurrentRoleId === RoleEnum.InternalTeam || context?.CurrentRoleId == RoleEnum.Admin) ? true : false,
        ModifiedBy: context?.Id,
      };
      
      const resp = await APICall(RemoveSurety, data);

      if (resp.Status === ApiStatus.OK && resp?.Data) {
        notify(ToastType.Success, "Surety replaced successfully.");
        setShowSuretyReplaceModal(false);
        setSuretyForReplacement(null);
        setNewSuretyMemberNo("");
        getSuretyDetails();
        setDashboardData([])
        setDataCount(0)
      } else if (resp.Status === ApiStatus.Error && resp?.Message) {
        notify(ToastType.Error, resp?.Message);
      } else {
        notify(
          ToastType.Error,
          "Surety replacement failed. Please contact administrator"
        );
      }
    } finally {
      hideLoader();
    }
  };

  const CustomCellComponent = (
    value: any,
    tableMeta: any,
    isDate: boolean = false
  ) => {
    return (
      <>
        <OverflowTip>
          <Typography
            fontFamily={"Georama-Regular"}
            fontSize={"14px"}
            component={"span"}
            noWrap={true}
          >
            {!isDate
              ? value
              : value
              ? moment(value).format(DATE_DISPLAY_FORMAT)
              : ""}
          </Typography>
        </OverflowTip>
      </>
    );
  };

  const CommonCellOptions = (isDate: boolean = false) => {
    return {
      filter: true,
      sort: true,
      sortDescFirst: true,
      customBodyRender: (value, tableMeta) =>
        CustomCellComponent(value, tableMeta, isDate),
    };
  };

  const Options = {
    showEmptyDataSourceMessage: true,
    selectableRows: "none",
    count: dataCount,
    rowsPerPage: pageSize,
    serverSide: true,
    rowsPerPageOptions: [],
    download: false,
    print: false,
    viewColumns: false,
    filter: false,
    search: false,
    pagination: false,
    onChangeRowsPerPage: () => {},
    onSearchChange: (searchText) => {
      if (searchText !== null) {
        setSearchText(searchText);
      } else {
        setSearchText("");
      }
      setStart(0);
    },
    onColumnSortChange: async (sortColumn, sortDirection) => {
      if (sortDirection === "asc") {
        setSortColumn(sortColumn);
        setSortDirection(sortDirection);
      }
      if (sortDirection === "desc") {
        setSortColumn(sortColumn);
        setSortDirection(sortDirection);
      }
      setStart(0);
    },
    onChangePage: async (page) => {
      setStart(page * pageSize);
    },
  };

  const GridColumns = [
    {
      name: "SuretyNo",
      label: "Surety No",
      options: CommonCellOptions(),
    },
    {
      name: "IsActiveSurety",
      label: "IsActiveSurety",
      options: {
        display:false,
        ...CommonCellOptions()
      },
    },
    {
      name: "MemberNo",
      label: "Member No",
      options: CommonCellOptions(),
    },
    {
      name: "FullName",
      label: "Member Name",
      options: CommonCellOptions(),
    },
    {
      name: "",
      label: "Action",
      options: {
        display: true,
        filter: false,
        sort: false,
        customBodyRender: (value: any, tableMeta: any) => {
          let id = tableMeta.rowData[0];
          let IsActiveSurety = tableMeta.rowData[1];
          const rowIndex = tableMeta.rowIndex;
          let surety = dashboardData[rowIndex];
          return (
            <>
              <Tooltip title="Remove">
                <IconButton
                  disabled={IsActiveSurety == 0 ? true : false}
                  aria-label="delete"
                  size="small"
                  color="error"
                  onClick={(e) => {
                    e.preventDefault();

                    setSuretyForReplacement(surety);
                    setShowSuretyReplaceModal(true);
                  }}
                >
                  <i className="fas fa-trash"></i>
                </IconButton>
              </Tooltip>
            </>
          );
        },
      },
    },
  ];

  useEffect(() => {
    getSuretyDetails();
  }, []);

  return (
    <div>
      {/* <div className="row justify-content-center">
        <table className="table w-auto">
          <thead
            style={{
              backgroundColor: "#DB233A",
              color: "white",
            }}
          >
            <tr>
              <th className="tableData">Surety No</th>
              <th className="tableData">Member No</th>
              <th className="tableData">Member Name</th>
              <th className="tableData">Action</th>
            </tr>
          </thead>
          <tbody>
            {sureties.map((surety, i) => {
              return (
                <tr>
                  <td className="tableData">{i + 1}</td>
                  <td className="tableData">{surety?.MemberNo}</td>
                  <td className="tableData">{surety?.FullName}</td>
                  <td className="tableData d-flex justify-content-center">
                    <Tooltip title="Remove">
                      <IconButton
                        aria-label="delete"
                        size="small"
                        color="error"
                        onClick={(e) => {
                          e.preventDefault();

                          setSuretyForReplacement(surety);
                          setShowSuretyReplaceModal(true);
                        }}
                      >
                        <i className="fas fa-trash"></i>
                      </IconButton>
                    </Tooltip>
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div> */}
      <div className="d-flex justify-content-center">
        <DynamicGrid
          options={Options}
          data={dashboardData}
          columns={GridColumns}
        />
      </div>

      <Modal
        centered
        show={showSuretyReplaceModal}
        onHide={() => {
          setShowSuretyReplaceModal(false);
          setSuretyForReplacement(null);
          setNewSuretyMemberNo("");
        }}
        style={{ backgroundColor: "rgba(255, 255, 255, 0.75)" }}
      >
        <Modal.Header
          className="custom-modal-header align-items-center"
          closeButton
          closeVariant="white"
        >
          <Modal.Title>Are you sure?</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="d-flex flex-column align-items-center">
            <div>
              <div className="form-group"></div>
              <label>
                A request will be sent to the borrower to remove your name from
                surety.
              </label>
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <div className="d-flex justify-content-center align-items-center">
            <div>
              <ButtonComponent
                className="btn btn-cancel"
                style={{
                  marginLeft: 5,
                  cursor: "pointer",
                }}
                icon={""}
                value={"No"}
                onClick={() => {
                  setShowSuretyReplaceModal(false);
                }}
              />
              <ButtonComponent
                className="btn btn-submit"
                style={{
                  marginLeft: 5,
                  cursor: "pointer",
                }}
                icon={""}
                value={"Yes"}
                onClick={() => {
                  removeSurety();
                }}
              />
            </div>
          </div>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default SuretyMemberView;
